import { MessageCircle, Image as ImageIcon, Globe, Search, Workflow, Code2, Film } from "lucide-react";

// The six official AlphaCore launch modules. Server (/api/modules) is the source
// of truth for name/desc/route/status/order — this map supplies icons + accents.
export const MODULE_COLOR_RGB = {
  pink: "255 58 168",
  green: "0 220 130",
  blue: "58 180 255",
  amber: "255 210 63",
  purple: "138 82 255",
  cyan: "0 229 255",
  orange: "255 138 34",
};

export const LAUNCH_MODULE_META = {
  "chat": { icon: MessageCircle, color: "pink", dm: "chat" },
  "image-studio": { icon: ImageIcon, color: "green", dm: "image" },
  "website-builder": { icon: Globe, color: "blue", dm: "website" },
  "research": { icon: Search, color: "amber", dm: "research" },
  "swarm": { icon: Workflow, color: "purple", dm: "swarm" },
  "code": { icon: Code2, color: "cyan", dm: "code" },
  "video-studio": { icon: Film, color: "orange", dm: "video" },
};

export const FALLBACK_MODULES = [
  { key: "chat", name: "AlphaCore AI", description: "Chat with AI, get answers, create, brainstorm.", route: "/agents/create", order: 10, status: "published", _visible: true },
  { key: "image-studio", name: "Image Generator", description: "Create, edit & enhance images with AI.", route: "/images", order: 20, status: "published", _visible: true },
  { key: "website-builder", name: "Website Builder", description: "Build modern websites in minutes.", route: "/websites", order: 30, status: "published", _visible: true },
  { key: "research", name: "AI Research", description: "Deep research and smart insights.", route: "/research", order: 40, status: "published", _visible: true },
  { key: "swarm", name: "Swarm Center", description: "Run AI agent swarms to get work done.", route: "/swarm", order: 50, status: "published", _visible: true },
  { key: "code", name: "AlphaCore Code", description: "Generate, analyze & improve code.", route: "/code", order: 60, status: "published", _visible: true },
];

export function moduleRgb(key) {
  const meta = LAUNCH_MODULE_META[key];
  return MODULE_COLOR_RGB[meta?.color || "purple"];
}

export function mergeModules(serverItems) {
  const visible = (serverItems || [])
    .filter((m) => LAUNCH_MODULE_META[m.key] && m._visible && m.status !== "archived" && m.status !== "hidden")
    .sort((a, b) => (a.order || 0) - (b.order || 0));
  const list = visible.length ? visible : FALLBACK_MODULES;
  return list.map((m) => ({ ...m, ...LAUNCH_MODULE_META[m.key], rgb: moduleRgb(m.key) }));
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}
